export default "__VITE_ASSET__7522f4e3__"